<template>
  <div>
    <v-card class="ma-3" v-if="profile !== null || profile !== undefined">
      <v-card-title class="p-0 pt-2 subtitle-2">
        <div class="m-0 ms-3">
          Customer ID:
          <span class="font-weight-bold">
            {{ profile.info.user_id }}
          </span>
        </div>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          small
          color="primary"
          class="text-capitalize me-2"
          @click="editname()"
        >
          <v-icon small>mdi-content-save-edit</v-icon> Edit Customer Profile
        </v-btn>
      </v-card-title>
      <v-divider class="mb-0"></v-divider>
      <v-card-text class="mt-2">
        <v-row class="d-flex justify-space-around">
          <v-col class="" cols="12" md="4" lg="3" sm="12">
            <div>
              <div>
                <img
                  v-if="profile.info.profile_pic"
                  :src="profile.info.profile_pic"
                  height="180px"
                  width="180px"
                  class="image_style"
                />
                <img
                  v-else
                  height="180px"
                  width="180px"
                  src="@/assets/users-icon.webp"
                  class="image_style"
                />
              </div>
              <v-btn
                color="primary"
                depressed
                small
                class="text-capitalize"
                width="180px"
                @click="triggerFileInput"
              >
                <v-icon small>mdi-camera</v-icon>Upload Image
                <v-file-input
                  v-model="profile_pic"
                  dense
                  accept="image/png, image/jpeg, image/bmp, image/bmp"
                  :show-size="1000"
                  prepend-icon=""
                  solo
                  truncate-length="15"
                  @change="onFileChange"
                  class="mt-2 d-none"
                  id="profile_image"
                >
                </v-file-input>
              </v-btn>
              <p class="primary--text text-uppercase pa-1 mb-0">
                {{ profile.info.first_name && profile.info.first_name }}
                {{ profile.info.middle_name && profile.info.middle_name }}
                {{ profile.info.last_name && profile.info.last_name }}

                <v-icon
                  small
                  class="mb-1"
                  :color="profile.info.status ? 'success' : 'warning'"
                  v-model="user_status"
                  >mdi-check-circle</v-icon
                >
              </p>
              <div
                class="d-flex chip-styles"
                v-if="profile.info && profile.info.partner_app_id"
              >
                App Id:
                <v-chip small class="" color="grey lighten-2">
                  <p class="mb-0 chip-styles">
                    {{ profile.info.partner_app_id }}
                  </p>
                </v-chip>
                <v-btn
                  x-small
                  fab
                  icon
                  @click="copypayIdfromGrid(profile.info.partner_app_id)"
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
              <div
                class="d-flex chip-styles"
                v-if="profile.info && profile.info.partner_secret_key"
              >
                Secret Key:
                <v-chip small class="" color="grey lighten-2">
                  <p class="mb-0 chip-styles">
                    {{ profile.info && profile.info.partner_secret_key }}
                  </p>
                </v-chip>
                <v-btn
                  v-if="profile.info && profile.info.partner_secret_key"
                  x-small
                  fab
                  icon
                  @click="
                    copypayIdfromGrid(
                      profile.info && profile.info.partner_secret_key
                    )
                  "
                >
                  <v-icon small>mdi-content-copy</v-icon>
                </v-btn>
              </div>
              <v-chip
                v-if="$route.query.risk_status && $route.query.percentage"
                label
                small
                :color="returnColor($route.query.risk_status)"
              >
                <span
                  >Risk : {{ $route.query.risk_status }}:
                  {{ $route.query.percentage }}%</span
                >
              </v-chip>
            </div>
          </v-col>
          <v-col class="mt-4" cols="12" md="4" lg="5" sm="12">
            <v-row>
              <table>
                <tbody>
                  <tr>
                    <td>ID Number</td>
                    <td>
                      <b>{{ profile.info.id_number }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Phone Number</td>
                    <td>
                      <b>{{ profile.info.mobile_number }} </b>
                    </td>
                  </tr>
                  <tr>
                    <td>Date Of Birth</td>
                    <td>
                      <b>{{ profile.info.dob }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Address</td>
                    <td>
                      <b>{{ profile.info.address }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Nationality</td>
                    <td>
                      <span v-if="profile.info.nationality_code"
                        ><b>{{
                          profile.info.nationality_code.nationality
                        }}</b></span
                      >
                      <span v-else></span>
                    </td>
                  </tr>

                  <tr>
                    <td>Occupation</td>
                    <td>
                      <span v-if="profile.info.occupation_code"
                        ><b>{{ profile.info.occupation_code.value }}</b></span
                      >
                      <span v-else></span>
                      <!-- <b>{{ profile.info.occupation_code.value }} </b> -->
                    </td>
                  </tr>
                  <tr>
                    <td>Employer Name</td>
                    <td>
                      <b>{{ profile.info.employer_name }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td>Source Of Fund</td>
                    <td>
                      <span v-if="profile.info.source_of_fund_code"
                        ><b>{{
                          profile.info.source_of_fund_code.value
                        }}</b></span
                      >
                      <span v-else></span>
                      <!-- <b>{{ profile.info.source_of_fund_code.value }} </b> -->
                    </td>
                  </tr>
                  <tr>
                    <td>Customer Type</td>
                    <td>
                      <b>{{ profile.info.user_type }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>Modified Date</td>
                    <td>
                      <b>{{ profile.info.modified_date }}</b>
                    </td>
                  </tr>

                  <tr>
                    <td>Modified By</td>
                    <td>
                      <b>{{ profile.info.modified_by }}</b>
                    </td>
                  </tr>
                </tbody>
              </table>
            </v-row>
          </v-col>
          <v-col cols="12" md="4" lg="4" sm="12">
            <v-card>
              <v-card-text>
                <v-timeline dense>
                  <v-timeline-item icon="mdi-account-plus">
                    <v-card class="pa-2">
                      <p class="m-0">Created Date</p>
                      <span>{{
                        profile.info.created_date
                          ? profile.info.created_date
                              .slice(0, 19)
                              .replace("T", " Time:")
                          : ""
                      }}</span>
                    </v-card>
                  </v-timeline-item>
                  <v-timeline-item
                    icon="mdi-account-check-outline"
                    color="cyan"
                  >
                    <v-card class="pa-2">
                      <p class="m-0">KYC Approved Date</p>
                      <span>{{
                        profile.info.approved_date
                          ? profile.info.approved_date
                              .slice(0, 19)
                              .replace("T", " Time:")
                          : ""
                      }}</span>
                    </v-card>
                  </v-timeline-item>
                  <v-timeline-item
                    icon="mdi-account-arrow-right-outline"
                    color="indigo"
                  >
                    <v-card class="pa-2">
                      <p class="m-0">First TXN Date</p>
                      <span class="font-weight-bold">{{
                        profile.info.first_tran_date
                          ? profile.info.first_tran_date
                              .slice(0, 19)
                              .replace("T", " Time:")
                          : ""
                      }}</span>
                    </v-card>
                  </v-timeline-item>
                  <v-timeline-item
                    icon="mdi-account-clock-outline"
                    color="pink"
                  >
                    <v-card class="pa-2">
                      <p class="m-0">Last TXN Date</p>
                      <span class="font-weight-bold">{{
                        profile.info.last_tran_date
                          ? profile.info.last_tran_date
                              .slice(0, 19)
                              .replace("T", " Time:")
                          : ""
                      }}</span>
                    </v-card>
                  </v-timeline-item>
                </v-timeline>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br />
      </v-card-text>
    </v-card>
    <v-card>
      <IndividualKYC :kycData="kycData" @getkycData="getIndividualKYC" />
    </v-card>
    <div class="text-center"></div>
    <v-dialog persistent v-model="dialog" width="1200">
      <v-card>
        <v-toolbar color="secondary" dark flat dense>
          <span>Edit Individual Profile</span>

          <v-spacer></v-spacer>
          <v-btn depressed icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-template v-if="dialog">
          <individual
            @CloseDialog="CloseDialog"
            :update_cust_id="customer_id"
            :cust_login_id="cust_login_id"
          />
        </v-template>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { indprofile } from "@/utils/validationCopy.js";
import IndividualKYC from "../KYC/Individual.vue";
import individual from "@/views/Compliance/AddnewCustomer/individual.vue";
import alerts from "@/mixins/alerts";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "",
  components: {
    individual,
    IndividualKYC,
  },
  data: () => ({
    ...indprofile,
    column: null,
    kycData: null,
    profile: {
      info: null,
      userStatus: null,
    },
    row: null,
    valid: true,
    statusRules: [(v) => !!v || "User Status is required"],
    statusdilogue: false,
    customer_id: "",
    cust_login_id: "",
    dialog: false,
    remiteeProfile: [],
    profile_pic: "",
    user_status: "",
  }),
  computed: {
    fullName() {
      let full_name = this.profile.info.first_name
        ? this.profile.info.first_name
        : "" + " " + this.profile.info.middle_name
        ? this.profile.info.middle_name
        : "" + " " + this.profile.info.last_name
        ? this.profile.info.last_name
        : "";

      return full_name;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    user_status(val) {
      console.log(val);
    },
  },
  mounted() {
    this.getProfileById();
    this.getIndividualKYC();
  },
  methods: {
    copypayIdfromGrid(payid) {
      navigator.clipboard.writeText(payid);
      this.showAlertSuccess("Copied successfully.");
    },
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    triggerFileInput() {
      document.getElementById("profile_image").click();
    },
    async onFileChange() {
      if (!this.profile_pic) return;
      let fileData = new FormData();
      fileData.append("profile_pic", this.profile_pic);
      this.loader = true;
      try {
        const responseData = await userService.fileChange(
          sessionStorage.getItem("addBeneInd"),
          fileData
        );
        if (responseData.data.status_code === 200) {
          this.profile.info.profile_pic = responseData.data.data[0];
          this.loader = false;
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.showAlertError(responseData.data.message);
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.showAlertError("Something went wrong please try again later.");
      }
    },

    close() {
      this.dialog = false;
    },
    // active satus update
    async profilestatus() {
      console.log("dd", this.user_status);
      const validate = this.$refs.UserListtatus.validate();
      if (validate === true) {
        try {
          const responseData = await userService.profileStatus(
            this.$route.query.id,
            this.user_status
          );
          console.log("responseData", responseData);
          if (responseData && responseData.status === 200) {
            this.getRemitteById(this.profiledetailsind.customer_id);
            this.showAlertSuccess(responseData.data.message);

            this.$refs.UserListtatus.reset();

            this.dialog = false;
          } else {
            this.showAlertError("Something went wrong please try again later.");
          }
        } catch (e) {
          console.error(e);
        }
      }
    },
    async getProfileById() {
      const params = {
        customer_id: !isNaN(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid) && !isNaN(parseFloat(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid)) ? parseInt(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid, 10) : (this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid),
      };
      this.loader = true;
      try {
        const responseData = await userService.getRemittenceId(params);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data && responseData.data.data.length > 0) {
            this.profile.info = responseData.data.data[0];
            this.profile.userStatus = responseData.data.data[0].userStatus;
            this.loader = false;
            this.$emit("profileInfo", responseData.data.data[0]);
          } else {
            this.profile = {
              info: null,
              userStatus: null,
            };
            this.showAlertError(responseData.data.message);
          }
        }
        console.log("remiteeProfile: ", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getIndividualKYC() {
      const params = {
        customer_id: !isNaN(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid) && !isNaN(parseFloat(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid)) ? parseInt(this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid, 10) : (this.$route.query.customer_id || this.$route.query.id || this.$route.query.customerid),
      };
      try {
        const responseData = await userService.getIndKYC(params);
        if (responseData.data.status_code === 200) {
          if (responseData.data.data && responseData.data.data.length > 0) {
            this.kycData = responseData.data.data;
          } else {
            this.kycData = null;
          }
        }
      } catch (e) {
        console.error(e);
      }
    },

    editname() {
      this.dialog = true;
      this.customer_id = this.$route.query.customerid;
      this.cust_login_id = this.$route.query.login_id;
    },
    CloseDialog() {
      this.getProfileById();
      this.getIndividualKYC();
      this.dialog = false;
    },
  },
};
</script>
<style></style>
<style lang="scss" scoped>
.upload-btn {
  position: absolute !important;
  z-index: 999;
  top: 135px;
  color: cadetblue;
  background: blueviolet;
  background: rgb(125, 198, 163);
  background: linear-gradient(
    50deg,
    rgba(125, 198, 163, 1) 0%,
    rgba(35, 216, 227, 1) 72%
  );
}

.avatar-shadow {
  box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -webkit-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
  -moz-box-shadow: 0px 0px 10px 0px rgba(50, 12, 112, 0.75);
}

.image_style {
  border-radius: 50%;
}
.chip-styles {
  max-width: 250px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 3px;
      vertical-align: middle;
      font-size: 15px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}

label {
  font-size: 15px;
  color: black;
}
</style>
